<template>
	<div class="innerBox">
		<h2 class="mb-4">Daftar PO Work Order</h2>

		<div class="row">
			<div class="form-input col-12 col-md-4">
				<label class="form-inline">Cari :</label>
				<input class="form-control" v-model="search"/>
			</div>
		</div>

		
		<div style="display:block;overflow-x:scroll">
			<table class="table text-center mt-3">
				<thead>
					<th>No.</th>
					<th>Nomor Work Order</th>
					<th>Nomor Polisi</th>
					<th>Tipe Mobil</th>
					<th>Asuransi</th>
					<th>Supplier</th>
					<th>Qty Sparepart</th>
					<th>Ordered</th>
					<th>Arrived</th>
					<th><i class="fa fa-cog"></i></th>
				</thead>
				<tbody v-for="(wo, index) in currWoList" :key="index" >
					<tr :class="{'bg-light-green' : wo.total_po_parts == wo.total_po_ordered && wo.total_po_ordered ==  wo.total_barang_datang , 'bg-light-red' : wo.total_po_parts != wo.total_po_ordered }">
						<td>
							{{index + 1}}
						</td>
						<td>
							{{wo.show_code}}
						</td>
						<td>
							{{wo.registration}}
						</td>
						<td>
							{{wo.car_name}}
						</td>
						<td>
							{{wo.insurance_company}}
						</td>
						<td>
							{{wo.supplier_name ? wo.supplier_name.split(',').join(', ') : ''}}
						</td>
						<td>
							{{wo.total_po_parts}}
						</td>
						<td>
							{{wo.total_po_ordered}}
						</td>
						<td>
							{{wo.total_barang_datang}}
						</td>
						<td>
							<button class="btn btn-primary w-100" @click="$router.push({name : 'PurchaseInventory' , params : {workOrderCode : JSON.stringify(wo)}})">&gt;</button>
						</td>
					</tr>
				</tbody>
			</table>
			<div class="text-center mt-3 mb-3">
				<div class="spinner-border" role="status" style="width:5rem;height:5rem" v-if="loading">
					<span class="sr-only" >Loading...</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			woList : [],
			search : '',
			currWoList : [],
			loading :false
		}
	},
	watch : {
		search : function () {
			let newWoList = []
			let keys = Object.keys(this.woList[0])


			for(var i = 0 ; i < this.woList.length ; i++) {
				for(var j = 0 ; j < keys.length ; j ++) {

					if(typeof this.woList[i][keys[j]] == 'string' && this.woList[i][keys[j]].toLowerCase().includes(this.search.toLowerCase())) {
						newWoList.push(this.woList[i])
						break;
					}
				}
			}

			this.currWoList = newWoList
		}
	},
	
	mounted() {
		this.getListOfWorkOrder()
	},
	methods : {
		getListOfWorkOrder () {
			this.woList = null;
			this.loading =true;
			this.$http.get('api/v1/workorder/listing/ongoing-purchasing')
			.then((resp) => {
				this.woList = resp.data.data[0]

				for(var i = 0; i < this.woList.length; i++) {
					// console.log(this.woList[i].car_name)
					this.woList[i].col_name = this.woList[i].form_code + ' - ' + this.woList[i].registration + ' - ' + this.woList[i].car_name
				}

				this.currWoList = JSON.parse(JSON.stringify(this.woList))
				this.loading = false
			})
			.catch((err) => { console.log(err) ; this.loading = false })
		}
	}
}
</script>

<style>
	.bg-light-green {
		background-color : rgb(211, 255, 233);
	}

	.bg-light-red {
		background-color : #ffbfbd;
	}
</style>